module.exports = [
	{
		"link": "https://register.gotowebinar.com/register/6951472434145730819?utm_source=navbar&utm_medium=c&utm_campaign=webinar_forrester",
		"title": "New joint webinar with Forrester!",
		"description": "Digital Transformation Beyond the Hype: What's the Role of Identity?.",
		"cta": "Join Us!",
		"iconColor": "#eb5424",
		"probability": 0.5
	},
	{
		"link": "http://auth0.com/jobs#job-openings",
		"title": "We are hiring!",
		"description": "If you care deeply about quality, teamwork, and want to build software that people love.",
		"cta": "Join Us!",
		"iconColor": "#eb5424",
		"probability": 0.5
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/featured-messages.json
// module id = 92
// module chunks = 0